import { useNavigate } from "react-router-dom";
import { BR, LOGO_FOOTER, US } from "../assets/image";
import { handleScrollToDiv } from "./navbar";

export function Footer({ texts, setIndex, index }: any) {
  const navigate = useNavigate();

  return (
    <footer className="bg-[#303133] py-12 text-left">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-2/4 xl:w-2/4 px-4 mb-8 lg:mb-0">
            <img src={LOGO_FOOTER} alt="" className="w-8/12 mb-10" />

            <p className="mb-2 text-white">
              <a
                href="contato@dhhealth.com.br"
                target="_blank"
                className="text-white"
              >
                contato@dmhealth.com.br
              </a>
            </p>
            <p className="text-white mb-4">
              RUA MANUEL DA NOBREGA, 354, CONJUNTO 133
              <br />
              PARAISO, SÃO PAULO-SP
              <br />
              CEP: 04.001-001
            </p>
            <div className="hidden lg:block">{texts.copy}</div>
          </div>
          <div className="w-full lg:w-1/4 xl:w-1/4 px-4 mb-8 lg:mb-0">
            <h5 className="text-lg font-bold mb-4 text-white">
              {texts.titleOne}
            </h5>
            <ul>
              {texts.items.map((item: any) => (
                <li className="mb-2">
                  <a
                    href="#inicio"
                    className="text-gray-600"
                    onClick={(e) => {
                      e.preventDefault();
                      handleScrollToDiv(item.id);
                    }}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          {/* <div className="w-full lg:w-1/4 xl:w-1/4 px-4 mb-8 lg:mb-0">
            <h5 className="text-lg font-bold mb-4 text-white">Newsletter</h5>
            <p className="text-gray-600 mb-4">
              Fique por dentro das novidades da DMHealth em primeira mão.
            </p>
            <form className="flex p-2 border rounded mt-10">
              <input
                type="email"
                placeholder="Email"
                className="w-full bg-[transparent] text-white"
              />
              <button
                type="submit"
                className="bg-white text-[#303133] font-bold py-2 px-4 rounded"
              >
                OK
              </button>
            </form>
          </div> */}
          <div className="w-full lg:w-1/4 xl:w-1/4 px-4 mb-8 lg:mb-0">
            <h5 className="text-lg font-bold mb-4 text-white">
              {texts.titleTwo}
            </h5>
            <ul>
              <li className="mb-2">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href=""
                  onClick={() => {
                    navigate("privacy");
                  }}
                  className="text-gray-600"
                >
                  {texts.itemOne}
                </a>
              </li>
              <li className="mb-2">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href=""
                  onClick={() => {
                    navigate("terms");
                  }}
                  className="text-gray-600"
                >
                  {texts.itemTwo}
                </a>
              </li>
            </ul>
            <div className="lg:hidden mt-10">
              <div className="flex items-center">
                {index === 0 ? (
                  <img
                    className="w-5 h-5"
                    src={BR}
                    alt="Bandeira dos Estados Unidos"
                  />
                ) : (
                  <img
                    className="w-5 h-5"
                    src={US}
                    alt="Bandeira dos Estados Unidos"
                  />
                )}
                <select
                  className="bg-transparent p-2 px-2 text-white"
                  value={index}
                  onChange={(e) => setIndex(Number(e.target.value))}
                >
                  <option className="text-[#303133]" value={0}>
                    Português
                  </option>
                  <option className="text-[#303133]" value={1}>
                    English
                  </option>
                </select>
              </div>
            </div>
            <div className="lg:hidden text-center">{texts.copy}</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
